import { render, staticRenderFns } from "./AccountingIncomeExpense.vue?vue&type=template&id=1d9b190c"
import script from "./AccountingIncomeExpense.vue?vue&type=script&lang=js"
export * from "./AccountingIncomeExpense.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports